import React from 'react';

import { useToast } from '@chakra-ui/react';

import { deleteWashHubs, fetchWashHubs } from 'api/washhub';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import { WashHubProps } from './WashHub.props';

import WashHubView from './WashHub.view';

const WashHubContainer = (_: WashHubProps) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const queryKey = 'wash-hub-locations';

  const { data: locations = [], isLoading } = useQuery(queryKey, fetchWashHubs);

  const { mutate, isLoading: isDeleting } = useMutation(deleteWashHubs);

  const _props = {
    locations,
    isLoading,
    isDeleting,
    onDelete: (ids: string[], _onSuccess: () => void) =>
      mutate(ids, {
        onSuccess: () => {
          toast({
            duration: 3000,
            isClosable: true,
            title: 'Success',
            status: 'success',
            description: 'Wash Hubs Deleted',
          });

          queryClient.invalidateQueries(queryKey, { exact: true });

          _onSuccess();
        },
      }),
  };

  return <WashHubView {..._props} />;
};

export default WashHubContainer;
